import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class ServiceID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
